<template>
    <div class="profile-pet">
        <div class="profile-pet__inner d-flex">
            <div class="profile-pet__header">

                <div class="profile-pet__header-image" :class="{'grayscale': pet.archive_reason === 'died'}"
                     :style="'background-image: url(/storage' + pet.avatar.path.replace('original', 'preview_l') + ')'" v-if="pet.avatar"></div>
                <a :href="'/projects/' + pet.id" class="profile-pet__header-link" v-if="type === 'projects'">{{$store.getters.t('organizations_profile_pet_view')}}</a>
                <a :href="'/pets/' + pet.id" class="profile-pet__header-link" v-else>{{$store.getters.t('organizations_profile_pet_view')}}</a>

                <div class="archive-reason d-flex" v-if="pet.archive_reason === 'home_found' || pet.archive_reason === 'adopted_by_volunteer'">
                    <img src="/assets/images/icons/home.svg" alt="">
                </div>

            </div>

            <div class="profile-pet__body">
                <div class="profile-pet__title d-flex">
                    <a :href="'/projects/' + pet.id" class="profile-pet__name" v-if="type === 'projects'" v-text="pet.name"></a>
                    <a :href="'/pets/' + pet.id" class="profile-pet__name" v-else v-text="pet.name"></a>
                    <div class="profile-pet__location" v-text="pet.location" v-if="pet.location"></div>
                </div>
                <div class="profile-pet__description" v-text="pet.ad_title"></div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['pet', 'type'],
    name: "ProfilePet",
    data(){
        return{}
    },
    mounted(){
    }
}
</script>

<style lang="scss" scoped>

</style>
